import { Box } from 'shared';
import styled from 'theme';

export const FooterWrapper = styled(Box)`
  background-color: ${props => props.theme.variables.colors.lightGrey};
  flex: none;
  flex-flow: column;
`;
